import { render, staticRenderFns } from "./DiscountLoading.vue?vue&type=template&id=39fde79b&"
import script from "./DiscountLoading.vue?vue&type=script&lang=js&"
export * from "./DiscountLoading.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DiscountLoading.vue"
export default component.exports